import interceptor from "../common/interceptor";
import { APIPaths } from "../common/constants";

// get all roles and permission table data  
export const GetRoles =  (token,checked) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosGet("Get", APIPaths.role, token, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })
    });
};

// API call for SAVE NEW ROLE
export const AddNewRole = (token, model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosPost("Post", APIPaths.add_role, model, token)
        .then(res => {
                resolve(res);
            })
            .catch(error => {
                console.log("Error while adding new role:", error?.response);
                reject(error?.response);
            });
    });
};


export const ChangeRolePermission = (token, model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosPost("Post", APIPaths.role_permissions, model, token)
        .then(res => {
                resolve(res);
            })
            .catch(error => {
                console.log("Error while adding new role:", error?.response);
                reject(error?.response);
            });
    });
};



export const DeleteRole = (id,token) =>{
    const url = `${APIPaths.role}${id}/`;
    return new Promise((resolve, reject) => {
        interceptor.axiosDelete("Delete", url,null, token).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })
    });
}

// Update Contact
export const UpdateRole = (token, id, model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosPut("Put", `${APIPaths.role}/${id}`, model, token)
            .then(res => resolve(res))
            .catch(error => {
                console.log("UpdateContact Error:", error?.response);
                reject(error?.response);
            });
    });
};

// API call for home page USER TASKS
// export const GetUserTask = (token) => {
//     return new Promise((resolve, reject) => {
//         interceptor.axiosGet("Get", APIPaths.button_status, token, null).then(res => {
//             resolve(res);
//         }).catch(error => {
//             console.log("error?.response?.data?.error", error?.response);
//             reject(error?.response);
//         })
//     });
// };

// API call foron time chart
// export const GetOntimeChart = (token,model) => {
//     return new Promise((resolve, reject) => {
//         interceptor.axiosPost("Post", APIPaths.ontime_chart, model, token)
//             .then(res => {
//                 resolve(res);
//             })
//             .catch(error => {
//                 console.log("Error fetching Ontime Chart:", error?.response);
//                 reject(error?.response);
//             });
//     });
// };




// export const ArchiveShipment = (id,token) =>{
//     const url = `${APIPaths.shipment_archive}`;
//     return new Promise((resolve, reject) => {
//         interceptor.axiosDelete("Delete", url,id, token).then(res => {
//             resolve(res);
//         }).catch(error => {
//             console.log("error?.response?.data?.error", error?.response);
//             reject(error?.response);
//         })
//     });
// }